import { usersPortfolioTranslations } from '@sh4res/bo-common/i18n/en/users/portfolio';

export const usersTranslations = {
  portfolio: usersPortfolioTranslations,
  actions: {
    remove_block: {
      title: 'Confirmation',
      confirm: 'Voulez-vous vraiment lever le blocage de cet e-mail ?',
      confirm_note:
        'REMARQUE : si l’envoi de l’e-mail échoue ou s’il est à nouveau signalé comme spam, il sera bloqué de façon permanente.',
      success: 'Le blocage a été supprimé avec succès',
      failure: 'Échec de la suppression du blocage : \n%{error}',
    },
    unremovable_block: {
      title: 'Cette adresse e-mail ne peut pas être débloquée',
      reason: {
        permanently_blocked:
          'Son blocage a déjà été levé une fois, puis les e-mails envoyés ont de nouveau été rejetés ou signalés comme spam. Le blocage est désormais définitif.',
        invalid:
          'Notre prestataire d’envoi a identifié cette adresse comme impossible à distribuer, par exemple à cause d’une faute de frappe ou d’une boîte mail inexistante.',
      },
      resolution:
        'Pour résoudre ce problème, demandez une autre adresse e-mail à la personne, puis modifiez la fiche et remplacez cette adresse par la nouvelle. Les e-mails seront ensuite envoyés à la nouvelle adresse.',
    },
  },
};
